import { render, staticRenderFns } from "./BenefitCardList.vue?vue&type=template&id=77a12d64&"
import script from "./BenefitCardList.vue?vue&type=script&lang=js&"
export * from "./BenefitCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports